(() => {
  const page = document.querySelector("[data-trm-dcr-page]");

  if (!page) {
    return;
  }

  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content"
  ];

  const incomingParams = new URLSearchParams(window.location.search);

  const hasIncomingAttribution = utmKeys.some((key) => {
    const value = incomingParams.get(key);
    return typeof value === "string" && value.trim() !== "";
  });

  const fallbackAttribution = {
    utm_source: "website",
    utm_medium: "internal",
    utm_campaign: "dcr_conversion",
    utm_content: "dcr_landing_cta"
  };

  page.querySelectorAll("[data-trm-dcr-cta]").forEach((link) => {
    const destination = new URL(
      link.getAttribute("href"),
      window.location.origin
    );

    utmKeys.forEach((key) => {
      destination.searchParams.delete(key);

      const value = hasIncomingAttribution
        ? incomingParams.get(key)
        : fallbackAttribution[key];

      if (typeof value === "string" && value.trim() !== "") {
        destination.searchParams.set(key, value.trim());
      }
    });

    link.setAttribute(
      "href",
      `${destination.pathname}${destination.search}${destination.hash}`
    );
  });

  const publishEvent = (eventName, attributes = {}) => {
    const payload = {
      event: eventName,
      source_page: "dcr_conversion",
      ...attributes
    };

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, payload);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
  };

  page.addEventListener("click", (event) => {
    const callLink = event.target.closest("[data-trm-dcr-call]");
    const quoteLink = event.target.closest("[data-trm-dcr-cta]");

    if (callLink) {
      publishEvent("dcr_click_to_call", {
        link_text: callLink.textContent.trim()
      });
    }

    if (quoteLink) {
      publishEvent("dcr_quote_request_click", {
        link_text: quoteLink.textContent.trim()
      });
    }
  });
})();
